import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCodeBox32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconCodeBox32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 8h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2m-4 2a4 4 0 0 1 4-4h18a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4zm9.207 3.172a1 1 0 1 0-1.414-1.415l-3.536 3.536L6.55 16l.707.707 3.536 3.536a1 1 0 0 0 1.414-1.415L9.38 16zm7.586 0a1 1 0 0 1 1.414-1.415l3.536 3.536.707.707-.707.707-3.536 3.536a1 1 0 0 1-1.414-1.415L22.62 16zm-2.09-1.605a1 1 0 0 1 .574 1.292L15.59 19.86a1 1 0 0 1-1.867-.716l2.687-7.002a1 1 0 0 1 1.292-.575"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCodeBox32);
